module.exports = __webpack_public_path__ + "img/public_client_analyse.87e5b2e0.png";